import DDRPlodForm from "../../components/DDRPlodForm/DDRPlodForm";
import {useLocation} from "react-router-dom";
import {useState} from "react";
import notLoginState from "../../asserts/notLoginState.png";
import inaccessibleState from "../../asserts/inaccessibleState.png";
import './ViewDDRPage.css'

export const ViewDDRPage = () => {
    const [aid, setAid] = useState<number>(() => {
        const storedUser = localStorage.getItem("DORS_USER");
        return storedUser ? JSON.parse(storedUser).Aid : 0;
    });

    const [authorityLv, setAuthorityLv] = useState<string>(() => {
        const storedUser = localStorage.getItem("DORS_USER");
        return storedUser ? JSON.parse(storedUser).AuthorityLv : '';
    });

    const location = useLocation();
    const ddrData = location.state?.ddrData || null;


    return (
        <div className="view_ddr">
            <>
                {(!ddrData && authorityLv === '') && (
                    <div className="inaccessible_state">
                        <img className="display_img" src={notLoginState} alt="Not signed in" />
                    </div>
                )}

                {(!ddrData && authorityLv === 'A') && (
                    <div className="inaccessible_state">
                        <img className="display_img" src={inaccessibleState} alt="Access Denied" />
                    </div>
                )}

                {(!!ddrData || (authorityLv !== 'A' && authorityLv !== '')) && (
                    <DDRPlodForm ddr={ddrData} aid={aid} authorityLv={authorityLv} />
                )}
            </>
        </div>
    );
}
